import { apiClient } from '../../gateways/api'
import type { FetchProjectmeldingValuelists } from '../types/FetchProjectmeldingValuelists'

export { fetchProjectmeldingValuelists, initialState }

const initialState: FetchProjectmeldingValuelists = {
  data: {
    status: [],
    tags: [],
  },
}

const fetchProjectmeldingValuelists = async (): Promise<
  FetchProjectmeldingValuelists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/valuelist/projectmelding',
    method: 'GET',
  })
  return data
}
